import myAxios from "../../utils/axiosWrapper";
import getConfig from "../../conf/config";
import {
  FINANCIAL_DETAIL_FETCH,
  FINANCIAL_DETAIL_FETCH_FAILURE,
  FINANCIAL_DETAIL_FETCH_SUCCESS,
  FINANCIAL_DETAIL_RESET,
} from "../actionTypes";

export const initFinancialDetail = () => {
  return async (dispatch) => {
    dispatch({ type: FINANCIAL_DETAIL_RESET });
  };
};

// Fetch operator infos between start date and end date
export const getOperatorSalesInfo = ({ operator, startDate, endDate }) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: FINANCIAL_DETAIL_FETCH });

      // Format dates using toISOString
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const formattedStartDate = new Date(startDate).toISOString();
      const formattedEndDate = new Date(endDate).toISOString();

      const base_url = `${getConfig().API_URL}/audio/api/v1/operators/${operator.id}`;
      // const operator_base_url = `${getConfig().API_URL}/audio/api/v1/operators`;

      // Make Axios request to fetch calls data from the backend
      const promises = [
        myAxios.get(
          `${base_url}/sales?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        ),
        myAxios.get(
          `${base_url}/sales/kpis?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        ),
        myAxios.get(
          `${base_url}/sales/grades?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        ),
        myAxios.get(
          `${base_url}/calls/?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        ),
      ];
      const [
        operator_sales_response,
        operator_sales_kpis_response,
        operator_sales_grade_response,
        total_calls_response,
      ] = await Promise.all(promises);
      let operator_sales_infos = { operator_id: operator.id };
      if (operator_sales_response?.data[0]?.data) {
        operator_sales_infos = {
          ...operator_sales_infos,
          operator_sales: operator_sales_response.data[0].data,
        };
      }
      if (operator_sales_kpis_response?.data[0]?.data) {
        operator_sales_infos = {
          ...operator_sales_infos,
          operator_sales_kpis: operator_sales_kpis_response.data[0].data,
        };
      }

      if (operator_sales_grade_response?.data?.grade) {
        operator_sales_infos = {
          ...operator_sales_infos,
          operator_sales_grade: operator_sales_grade_response?.data?.grade || 0,
        };
      }

      if (total_calls_response?.data[0]?.data?.total_calls) {
        operator_sales_infos = {
          ...operator_sales_infos,
          operator_sales_kpis: {
            ...operator_sales_infos.operator_sales_kpis,
            total_calls: total_calls_response?.data[0]?.data?.total_calls || 0,
          },
        };
      }

      // end
      dispatch({ type: FINANCIAL_DETAIL_FETCH_SUCCESS, payload: { ...operator_sales_infos } });
    } catch (error) {
      console.log(error);
      dispatch({ type: FINANCIAL_DETAIL_FETCH_FAILURE, payload: error.message });
      throw error;
    }
  };
};
